import router from '../../router/index'
import axios from 'axios'
import * as errorMapping from '../errorMessageMapping'

export default {
    ADDGIFTS ({ commit }, {gift}) {
        return axios.post('registration/addGifter', gift).then((response) => {
            // console.log('actual gift', gift)
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                window.logEvents('Send-Gift Page', 'Gift Sent', 'Gift sent to ' + gift.userGifts.length.toString() + ' email(s)')
                // commit('setUser', { user: data.payload })
                // commit('setError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                commit('setError', { error: {show: true, message: data.message} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    ADDCORPORATEGIFTS ({ commit }, {gift}) {
        return axios.post('messagereader/addGifteesInQueue', gift).then((response) => {
            // console.log('actual gift', gift)
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
            } else {
                commit('setError', { error: {show: true, message: data.message} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETGIFTEE ({ commit }, giftCode) {
        return axios.get(`registration/getByGifteeId/${giftCode}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setGiftee', { payload: data.payload })
                commit('setError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                commit('setError', { error: {show: true, message: data.message} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETACCENTUREGIFTEE ({ commit }, giftCode) {
        return axios.get(`registration/getGifteeByCorpId/${giftCode}/1`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setGiftee', { payload: data.payload })
                commit('setGiftingError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                commit('setGiftingError', { error: {show: true, message: 'You have reached the maximum number of accounts registered for this trial offer.'} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETCORPORATIONGIFTEE ({ commit }, giftDetails) {
        return axios.get(`registration/getGifteeByCorpId/${giftDetails[0]}/${giftDetails[1]}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setGiftee', { payload: data.payload })
                commit('setGiftingError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                commit('setGiftingError', { error: {show: true, message: 'You have reached the maximum number of accounts registered for this trial offer.'} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETCORPORATIONPLAN ({ commit }, giftDetails) {
        return axios.get(`registration/getGifteeByCorpId/${giftDetails[0]}/${giftDetails[1]}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorporateClientPlanId', data.payload.packageId)
                commit('setGiftingError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                // commit('setGiftingError', { error: {show: true, message: 'You have reached the maximum number of accounts registered for this trial offer.'} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    SETGIFTID ({commit}, packageId) {
        commit('setSelectedGiftId', {giftId: packageId})
        router.push('/sendgift')
        window.scrollTo(0, 0)
    },
    SAVEGIFTEE ({ commit }, {giftee}) {
        return axios.post('registration/addGiftee', giftee).then((response) => {
            const { data: { data } } = response
            let userToken = response.headers.authorization
            if (data && !data.error && data.completed) {
                commit('setUser', { user: data.payload })
                sessionStorage.setItem('loggedUserTemp', JSON.stringify(data.payload))
                localStorage.setItem('token', userToken)
                commit('setError', { error: {show: false, message: ''} })
                //
                //
                //
                let eventCorporationId = ''
                let eventRedirectUri = ''
                if (localStorage.getItem('event_corporation_id')) {
                    eventCorporationId = localStorage.getItem('event_corporation_id')
                }
                if (localStorage.getItem('event_redirect_uri')) {
                    eventRedirectUri = localStorage.getItem('event_redirect_uri')
                }
                if (eventCorporationId !== '' && eventRedirectUri !== '') {
                    // Remove any trailing slash
                    eventRedirectUri = eventRedirectUri.replace(/\/$/, '')
                    // Extract the part after the last slash
                    const parts = eventRedirectUri.split('/')
                    let eventId = parts[parts.length - 1]
                    console.log('4A===================================>  EVENT ID = ', eventId)
                    //
                    router.push('/event/' + eventId)
                    if (localStorage.getItem('event_corporation_id')) {
                        localStorage.removeItem('event_corporation_id')
                    }
                    if (localStorage.getItem('event_redirect_uri')) {
                        localStorage.removeItem('event_redirect_uri')
                    }
                } else {
                    //
                    //
                    //
                    let skptInterests = false
                    let defaultLandingPage = '/mytone'
                    if (data.payload.corporation && data.payload.corporation.skipInterestPage.toString() === '1') {
                        skptInterests = true
                    }
                    if (data.payload.corporation && data.payload.corporation.landingPage && data.payload.corporation.landingPage.length > 2 && data.payload.corporation.landingPage.indexOf('/') > -1) {
                        defaultLandingPage = data.payload.corporation.landingPage
                    }
                    // console.log('interest page setting', skptInterests)
                    // console.log('default landing setting', defaultLandingPage)
                    if (skptInterests) {
                        router.push(defaultLandingPage)
                    } else {
                        router.push('/interests')
                    }
                }
            } else {
                commit('setError', { error: {show: true, message: errorMapping.getCustomErrorMessage(data.message)} })
            }
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETCORPORATECLIENTS ({ commit }) {
        return axios.get(`/corporations`).then((response) => {
            const { data: { data } } = response
            commit('setCorporateClients', {clients: data})
                // router.push('/interests')
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETCORPORATECLIENT ({ commit }, corporationId) {
        return axios.get(`/corporations/findByCorporationId/${corporationId}`).then((response) => {
            console.log('INSIDE store/gifts/actions.js -----> corporationId = ', corporationId)
            const { data: { data } } = response
            commit('setCorporateClient', {client: data})
            console.log('INSIDE store/gifts/actions.js -----> data = ', data)
            if (localStorage.getItem('corporateClientObject')) {
                localStorage.removeItem('corporateClientObject')
                localStorage.setItem('corporateClientObject', JSON.stringify(data))
            } else {
                localStorage.setItem('corporateClientObject', JSON.stringify(data))
            }
            // Set custom Color if defined else fall back to original theme
            // let headerColor = '#f0617d'
            // let footerColor = '#f0617d'
            // let buttonColor = '#f0617d'
            // let headingColor = '#f0617d'
            let headerColor = '#44bda8'
            let footerColor = '#44bda8'
            let buttonColor = '#44bda8'
            let headingColor = '#44bda8'
            // header
            if (data && data.groupDefinitions && data.groupDefinitions.headerColor) {
                headerColor = data.groupDefinitions.headerColor
            }
            // footer
            if (data && data.groupDefinitions && data.groupDefinitions.footerColor) {
                footerColor = data.groupDefinitions.footerColor
            }
            // button
            if (data && data.groupDefinitions && data.groupDefinitions.buttonColor) {
                buttonColor = data.groupDefinitions.buttonColor
            }
            // heading
            if (data && data.groupDefinitions && data.groupDefinitions.headingColor) {
                headingColor = data.groupDefinitions.headingColor
            }
            console.log('updated header color', headerColor)
            commit('setCorpHeaderColor', headerColor)
            commit('setCorpFooterColor', footerColor)
            commit('setCorpButtonColor', buttonColor)
            commit('setCorpHeadingColor', headingColor)
            // router.push('/interests')
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    SWITCH_CORPORATION ({ commit }, corporationId) {
        return axios.get(`/corporations/findByCorporationId/${corporationId}`).then((response) => {
            const { data: { data } } = response
            commit('setSwitchCorporateClient', {client: data})
            if (sessionStorage.getItem('switchClientObject')) {
                sessionStorage.removeItem('switchClientObject')
                sessionStorage.setItem('switchClientObject', JSON.stringify(data))
            } else {
                sessionStorage.setItem('switchClientObject', JSON.stringify(data))
            }
            // Set custom Color if defined else fall back to original theme
            // let headerColor = '#f0617d'
            // let footerColor = '#f0617d'
            // let buttonColor = '#f0617d'
            // let headingColor = '#f0617d'
            let headerColor = '#44bda8'
            let footerColor = '#44bda8'
            let buttonColor = '#44bda8'
            let headingColor = '#44bda8'
            // header
            if (data && data.groupDefinitions && data.groupDefinitions.headerColor) {
                headerColor = data.groupDefinitions.headerColor
            }
            // footer
            if (data && data.groupDefinitions && data.groupDefinitions.footerColor) {
                footerColor = data.groupDefinitions.footerColor
            }
            // button
            if (data && data.groupDefinitions && data.groupDefinitions.buttonColor) {
                buttonColor = data.groupDefinitions.buttonColor
            }
            // heading
            if (data && data.groupDefinitions && data.groupDefinitions.headingColor) {
                headingColor = data.groupDefinitions.headingColor
            }
            commit('setCorpHeaderColor', headerColor)
            commit('setCorpFooterColor', footerColor)
            commit('setCorpButtonColor', buttonColor)
            commit('setCorpHeadingColor', headingColor)
            // router.push('/interests')
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GETCORPORATECLIENTFORDEMO ({ commit }, corporationId) {
        return axios.get(`/corporations/findByCorporationId/${corporationId}`).then((response) => {
            const { data: { data } } = response
            if (data) {
                commit('setCorporateClientForDemo', {client: data})
            } else {
                commit('setCorporateClientForDemo', {client: null})
            }
            // router.push('/interests')
        }, (err) => {
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GET_PARENT_CORPORATION ({ commit }, corporationId) {
        return axios.get(`corporations/findCorporationSiblings/${corporationId}`).then((response) => {
            const { data: { data } } = response
            commit('setParentCorporation', {parentCorp: data})
            // router.push('/interests')
        }, (err) => {
            commit('setParentCorporation', {parentCorp: null})
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GET_CORP_RESTRICTED_REGIONS ({ commit }, corporationId) {
        return axios.get(`corporations/getCorpRestrictedRegions/${corporationId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorpRestrictedRegions', { payload: data.payload })
                commit('setError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                commit('setCorpRestrictedRegions', {payload: null})
            }
            // router.push('/interests')
        }, (err) => {
            commit('setCorpRestrictedRegions', {payload: null})
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    GET_CORPORATION_REGIONS ({ commit }, corporationId) {
        return axios.get(`corporations/getCorporationRegions/${corporationId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorporationRegions', { payload: data.payload })
                commit('setError', { error: {show: false, message: ''} })
                // router.push('/interests')
            } else {
                commit('setCorporationRegions', {payload: null})
            }
            // router.push('/interests')
        }, (err) => {
            commit('setCorporationRegions', {payload: null})
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    },
    LOG_SIGNUP_ATTEMPT ({ commit }, errorPayload) {
        return axios.post('/logging/writeActivityToQueue', errorPayload).then((response) => {
            console.log('LOG_SIGNUP_ATTEMPT : error successfully logged: ', errorPayload)
        }, (err) => {
            console.log('LOG_SIGNUP_ATTEMPT : err ', err)
        })
    },
    GETCORPORATECLIENT_GIFT_DETAILS ({ commit }, giftInfo) {
        return axios.get(`/registration/getGifteeByCorpId/${giftInfo.giftCode}/${giftInfo.corporationId}`).then((response) => {
            const { data: { data } } = response
            if (data && !data.error && data.completed) {
                commit('setCorporateGiftInfo', {gift: data.payload})
            } else {
                commit('setCorporateGiftInfo', {gift: null})
            }
            // router.push('/interests')
        }, (err) => {
            commit('setCorporateGiftInfo', {gift: null})
            console.log('err ', err)
            commit('setError', { error: {show: true, message: 'An error occurred while processing the request'} })
        })
    }
}



// WEBPACK FOOTER //
// ./src/store/gifts/actions.js